import Button from "@material-ui/core/Button";
import { styled } from "@material-ui/core/styles";

export const StyledButton = styled(Button)({
  height: "36px",
  padding: "0 14px",
  boxShadow: "0 4px 12px -4px rgba(58,134,216,0.5)",
  background: "#3a86d8",
  color: "#ffffff",
  border: "none",
  borderRadius: "8px",
  fontFamily: "inherit",
  fontWeight: 600,
  fontSize: "13px",
  textAlign: "center",
  minWidth: "auto",
  gap: "8px",
  "&:hover": {
    background: "#2f75c4",
    border: "none",
    color: "#ffffff",
    boxShadow: "0 4px 12px -4px rgba(58,134,216,0.65)",
  },
  textTransform: "none",
});
